/*
 * Derive the current DISPLAY order of pages by folding reorder-page edits over
 * the original page sequence. The viewer renders from the original bytes (pages
 * never physically move until save), so without this the thumbnail/page order
 * wouldn't reflect pending reorders.
 *
 * Returns an array of ORIGINAL page indices in display order. Each reorder-page
 * edit is an array-move (remove at `from`, insert at `to`) applied in order,
 * matching the driver's sequential movePage(from, to) at save time — so the UI
 * preview and the saved output agree. reorder from/to are positions in the
 * *current* display order (that's what the UI emits), which is exactly how a
 * sequential fold consumes them.
 */

import type { Edit } from '@pdf-ticket/pdf-core';

export function effectiveOrder(pageCount: number, edits: ReadonlyArray<Edit>): number[] {
  const order = Array.from({ length: Math.max(0, pageCount) }, (_, i) => i);
  for (const e of edits) {
    if (e.kind !== 'reorder-page') continue;
    const { from, to } = e;
    if (from < 0 || from >= order.length || to < 0 || to >= order.length) continue;
    const [moved] = order.splice(from, 1);
    if (moved === undefined) continue;
    order.splice(to, 0, moved);
  }
  return order;
}
